import React, { useState, useRef } from 'react';
import '../styles/TrainingTestSection.css';

function parseBold(text) {
  const parts = (text || '').split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) => i % 2 === 1 ? <strong key={i}>{part}</strong> : part);
}

export default function TrainingQuizSection({ section, onReady }) {
  const questions = section?.quizContent?.questions || [];
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const readyFiredRef = useRef(false);

  const handleAnswer = (qIdx, optIdx) => {
    if (submitted) return;
    setAnswers(prev => ({ ...prev, [qIdx]: optIdx }));
  };

  const handleSubmit = () => {
    setSubmitted(true);
    if (!readyFiredRef.current) {
      readyFiredRef.current = true;
      onReady && onReady();
    }
  };

  const handleReload = () => {
    setAnswers({});
    setSubmitted(false);
  };

  if (questions.length === 0) {
    return <div className="text-muted fst-italic">Sin preguntas configuradas.</div>;
  }

  const allAnswered = Object.keys(answers).length >= questions.length;

  return (
    <div>
      {questions.map((q, qIdx) => {
        const correctIdx = (q.options || []).findIndex(o => o.correct);
        const isCorrect = answers[qIdx] === correctIdx;

        return (
          <div key={qIdx} id={`quiz-${section._id}-${qIdx}`} className="answers-container mb-4">
            <div className="question-container d-flex justify-content-between align-items-start">
              <h2 className="font-size-12">
                <strong>{qIdx + 1}.</strong> {parseBold(q.question)}
              </h2>
              {!submitted && answers[qIdx] !== undefined && (
                <button
                  className="btn btn-sm btn-outline-secondary ms-2 flex-shrink-0"
                  onClick={() => setAnswers(prev => { const next = { ...prev }; delete next[qIdx]; return next; })}
                >
                  Desmarcar
                </button>
              )}
            </div>
            <div className="Preguntas">
              {(q.options || []).map((opt, optIdx) => (
                <label
                  key={optIdx}
                  className="d-flex align-items-center gap-2 mb-2"
                  style={{ cursor: submitted ? 'default' : 'pointer' }}
                >
                  <input
                    type="radio"
                    name={`quiz-${section._id}-${qIdx}`}
                    value={optIdx}
                    checked={answers[qIdx] === optIdx}
                    onChange={() => handleAnswer(qIdx, optIdx)}
                    disabled={submitted}
                  />
                  {parseBold(opt.text)}
                </label>
              ))}
            </div>
            {submitted && (
              <div className={`alert ${isCorrect ? 'alert-success' : 'alert-danger'} mb-0`}>
                {isCorrect ? (
                  <span><i className="fas fa-check me-2" />Correcto</span>
                ) : (
                  <span>
                    <i className="fas fa-times me-2" />
                    Respuesta correcta: {(q.options || []).find(o => o.correct)?.text || 'N/A'}
                  </span>
                )}
              </div>
            )}
          </div>
        );
      })}

      {!submitted ? (
        <button
          className="btn btn-primary mt-2"
          onClick={handleSubmit}
          disabled={!allAnswered}
        >
          Verificar respuestas
        </button>
      ) : (
        <button
          className="btn btn-outline-secondary mt-2"
          onClick={handleReload}
        >
          <i className="fas fa-rotate-left me-2" />
          Volver a intentarlo
        </button>
      )}
    </div>
  );
}
